import React from 'react';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
	Logo: {
		height: 95,
		width: 95,
		display: 'block',
	},
}));

// Airchain A4 "The Stack": four roll-up caption rows cut by a descending
// diagonal of slots -- the rows say captions, the diagonal says the chain.
// Pure positive space, no counters or knockouts, so it stays crisp at any
// size. The gaps compress downward 4.5 : 3.0 : 1.5 and must never be
// regularised. No brand colour by design -- currentColor only; green,
// amber and red are reserved for status. See
// airchain-website/redesign/identity.html section 01 for the full spec.
export default function Logo(props) {
	const classes = useStyles();

	return (
		<svg className={classes.Logo} viewBox="0 0 24 19" role="img" aria-label="Airchain" fill="currentColor">
			<rect x="0" y="0" width="18" height="2.5" />
			<rect x="20" y="0" width="4" height="2.5" />
			<rect x="0" y="7" width="13" height="2.5" />
			<rect x="15" y="7" width="9" height="2.5" />
			<rect x="0" y="12.5" width="8" height="2.5" />
			<rect x="10" y="12.5" width="14" height="2.5" />
			<rect x="0" y="16.5" width="3" height="2.5" />
			<rect x="5" y="16.5" width="19" height="2.5" />
		</svg>
	);
}
